import React, { useEffect, useState } from 'react';
import './Slider.css';
import InfoBar from '../InfoBars';

interface SliderProps {
  label: string;
  min: number;
  max: number;
  defaultValue:number;
  smallStep: number;
  largeStep: number;
  onChange: (value: number) => void;
  required?: boolean;
  isDisabled?:boolean;
  inputType?: 'error' | 'success' | 'general';
  errorMessage?: string;
}

const Slider:React.FC<SliderProps> = ({
  label,
  min,
  max,
  defaultValue,
  smallStep,
  largeStep,
  onChange,
  required = true,
  inputType,
  errorMessage
}) => {  

  const [value, setValue] = useState<number>(defaultValue);
  const isInteger = Number.isInteger(smallStep) && Number.isInteger(largeStep);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);


  const increment = (amount: number) => {
  const newValue = isInteger ? (value + amount) : parseFloat((value + amount).toFixed(1));
  const updatedValue = newValue > max ? max : newValue;
  setValue(updatedValue);
  onChange(updatedValue);
  };

  const decrement = (amount: number) => {
    const newValue = isInteger ? (value - amount) : parseFloat((value - amount).toFixed(1));
    const updatedValue = newValue <min ? min : newValue;
    setValue(updatedValue);
    onChange(updatedValue);
  };

  
return (
    <>  
      <div className="styled-incrementer">
            {label && <div className={`incrementer-label ${required && 'yes'}`}>{label}</div>}
            <div className="incrementer-controls">
                <button type="button" className="arrow-button" onClick={() => decrement(largeStep)}>{'<<'}</button>
                <button type="button" className="arrow-button" onClick={() => decrement(smallStep)}>{'<'}</button>
                <div className="value-display">
                  {isInteger ? Number(value) : Number(value).toFixed(1)}
                </div>
                <button type="button" className="arrow-button" onClick={() => increment(smallStep)}>{'>'}</button>
                <button type="button" className="arrow-button" onClick={() => increment(largeStep)}>{'>>'}</button>
            </div>
        {inputType === 'error' && errorMessage ? (
         <InfoBar
            variant="danger"
            message={errorMessage}
            className="input_field_class"
          />
        ) : null}
        </div>
</>

    );
};

export default Slider;
